var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('web-heard'),_c('router-view'),_c('callus-form',{staticStyle:{"margin-top":"100px"},attrs:{"id":"callusForm"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }